module.exports = __webpack_public_path__ + "img/租赁房.d76157db.png";